<template>
  <section id="admin-filter">
    <h4>User Group filter</h4>
    <div class="form-group">
      <label for="pa-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="pa-name" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="pa-name" class="form-label">Code</label>
      <input type="text" class="form-control" id="pa-name" v-model="entity.code"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'UserGroupFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          name: '',
          code: ''
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/UserGroup/UserGroupFilter.vue